import React from "react";
import styled from "styled-components";
import { Button } from "@mui/material";

import { LiveSupport } from "../helpers/ContactHelpers";

export function LiveChat() {
    const openLiveSupport = () => new LiveSupport().open();
    return (
        <Container data-testid="live-chat">
            <Button variant="contained" fullWidth color="primary" onClick={openLiveSupport}>
                Live chat
            </Button>
        </Container>
    );
}

const Container = styled.div`
    text-align: center;
    width: 280px;
    margin-top: 2rem;

    @media (min-width: 959px) {
        display: none;
    }
`;
